import React, { ReactElement } from 'react';
import ReactApexChart from 'react-apexcharts';

interface Props<TypeLineChart> {
    name?: string;
    chartData: number[];
    chartLabels?: Array<string>;
    title?: string;
}

export default function AreaChart<TypeLineChart>({ name, chartData, chartLabels, title }: Props<TypeLineChart>): ReactElement {

    const data = {

        series: [{
            name: name || '',
            data: chartData || [],
        }],
        options: {
            chart: {
                // type: 'area',
                // height: 350,
                zoom: {
                    enabled: true,
                    // type: 'x',
                }
            },
            // toolbar: {
            //     enabled: true,
            //     zoom: false,
            // },
            dataLabels: {
                enabled: false
            },
            stroke: {
                // curve: ['smooth']
            },

            title: {
                text: title || '',
                // align: 'left'
            },
            labels: chartLabels || [],
            xaxis: {
                // type: 'datetime',
                // rotate: 45,
                labels: {
                    rotate: -45
                  },
            },
            yaxis: {
                opposite: true
            },
            legend: {
                // horizontalAlign: 'left'
            },
            markers: {
                size: 4
            },
            colors: ['#055DC9'], // color of line
        },

    };

    return (
        <React.Fragment>
            <ReactApexChart options={data.options} series={data.series} type="area" height={350} />
        </React.Fragment>
    )
}
